import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Work", href: "#gallery" },
  { label: "Lookout", href: "#lookout" },
  { label: "Services", href: "#services" },
  { label: "Studio", href: "#about" },
  { label: "Book", href: "#book" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#E5A93B]">
            AQUA / AERIALS
          </span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-white/40 group-hover:text-white transition">
            LKA
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="text-sm tracking-wide text-white/70 hover:text-white transition-colors duration-300 relative group"
            >
              {item.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-[#E5A93B] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#book"
          data-testid="header-book-cta"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-[#E5A93B] text-black text-xs font-bold uppercase tracking-[0.18em] hover:bg-[#FACC15] transition-colors"
        >
          Book a Shoot
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className="text-white/80 hover:text-[#E5A93B] text-lg"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-cta"
              className="mt-4 inline-flex items-center justify-center px-5 py-3 bg-[#E5A93B] text-black text-xs font-bold uppercase tracking-[0.18em]"
            >
              Book a Shoot
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
